export default {"src":"/_next/static/media/up-graph.3101b270.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};